import {createAction} from "@reduxjs/toolkit";

export const loadCalculation = createAction("calculation/load", (calculation, organization, marginTax) => ({
    payload: {...calculation, organization, marginTax}
}))
